import React, { useState, useRef, useEffect } from 'react';

interface InfoTooltipProps {
    content: React.ReactNode;
    iconSize?: number;
    width?: number;
}

export default function InfoTooltip({ content, iconSize = 14, width = 280 }: InfoTooltipProps) {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open) return undefined;
        const handler = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [open]);

    return (
        <div ref={ref} className="relative inline-flex">
            <button
                type="button"
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}
                onClick={(e) => {
                    e.stopPropagation();
                    setOpen((v) => !v);
                }}
                className="text-slate-400 hover:text-slate-600 transition-colors flex items-center"
                aria-label="More information"
            >
                <span className="material-symbols-outlined" style={{ fontSize: `${iconSize}px` }}>
                    info
                </span>
            </button>
            {open && (
                <div
                    onMouseEnter={() => setOpen(true)}
                    onMouseLeave={() => setOpen(false)}
                    className="absolute z-50 left-1/2 -translate-x-1/2 top-full mt-1.5 bg-slate-900 text-white text-xs rounded-md p-3 shadow-lg leading-relaxed"
                    style={{ width: `${width}px` }}
                >
                    <div
                        className="absolute left-1/2 -translate-x-1/2 -top-1 w-2 h-2 bg-slate-900 rotate-45"
                        aria-hidden
                    />
                    {content}
                </div>
            )}
        </div>
    );
}
